import { Button } from "@transfr-inc/dashboard-components/forms";

import { BetaBadge } from "@components/custom/content";
import { AILayoutBackground } from "@src/layouts/ai";

import { AiCurriculumLauncher } from "./ai-curriculum";

import "./classroom.course-builder.guard.scss";

export const ClassrooomCourseBuilderGuard = ({
  orgCode,
  classroomId,
  courseId,
  onCourseBuilt,
  onBuildYourOwn,
}) => {
  return (
    <div className="course-builder-guard-container">
      <div className="course-builder-guard-title">
        <h3>
          You currently don’t have any content set up for this classroom. Please
          choose from the options below.
        </h3>
      </div>
      <div className="course-builder-guard-actions">
        <AILayoutBackground className="course-builder-guard-action ai-curriculum">
          <BetaBadge />
          <div className="content">
            <div className="description">
              <h2>Let us help!</h2>
              <p>
                We can recommend sims and <br />
                resources for your classroom.
              </p>
            </div>
            <div className="action">
              <AiCurriculumLauncher
                orgCode={orgCode}
                classroomId={classroomId}
                hasExistingCourse={!!courseId}
                onCourseBuilt={onCourseBuilt}
                label="Get Recommendations"
                hideIcon
              />
              <span>Powered by Transfr Intelligence</span>
            </div>
          </div>
          <img src="/images/ai-curriculum/banner.png" />
        </AILayoutBackground>
        <span>OR</span>
        <div className="course-builder-guard-action build-your-own">
          <span>Manually add content using course builder.</span>
          <Button onClick={onBuildYourOwn}>Build Your Own</Button>
        </div>
      </div>
    </div>
  );
};
